var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[_c('div',{staticClass:"page",class:_vm.newSkin ? ' new-skin' : ''},[_c('PreLoader'),_c('Gradient'),_c('div',{staticClass:"container opened",attrs:{"data-animation-in":_vm.animationFunction.animationIn,"data-animation-out":_vm.animationFunction.animationOut}},[_vm._t("default")],2),(!_vm.noSidebar)?_c('Sidebar'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }